import { useEffect, useState } from "react";
import { MapContainer, TileLayer, Marker, useMapEvents } from "react-leaflet";
import L from 'leaflet';
import MapAutoMove from "./MapAutoMove";

const MapPicker = ({ onSelect }) => {
    const [position, setPosition] = useState(null);
    const markerIcon = L.icon({
        iconUrl: "https://cdn-icons-png.flaticon.com/512/684/684908.png",
        iconSize: [32, 32]
    });
    const [initialCenter, setInitialCenter] = useState([9.9, -84.0]);

    useEffect(() => {
        if (!navigator.geolocation) return;
        navigator.geolocation.getCurrentPosition((pos) => {
            const { latitude, longitude } = pos.coords;
            const center = [latitude, longitude];
            setInitialCenter(center);
            setPosition(center);
            if (onSelect) onSelect({ lat: latitude, lng: longitude });
        },
            () => {
                console.warn("no se pudo obtener la ubicación");
            })
    }, [])

    const MapClickHandler = () => {
        useMapEvents({
            click(e) {
                const { lat, lng } = e.latlng;
                setPosition([lat, lng]);
                if (onSelect) onSelect({ lat, lng });
            }
        });
        return position ? <Marker position={position} icon={markerIcon} /> : null;
    };
    return (
        <MapContainer
            center={[9.9, -84.0]}
            zoom={13}
            style={{ height: "350px", width: "100%" }}>
            <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                attribution="© OpenStreetMap contributors"
            />
            <MapClickHandler />
            <MapAutoMove position={position} />
            {position && <Marker position={position} icon={markerIcon} />}
        </MapContainer>
    )
}
export default MapPicker;